const paymentActionConstants = {
  GET_PAYMENTS: 'GET_PAYMENTS',
  GET_PAYMENTS_SUCCESS: 'GET_PAYMENTS_SUCCESS',
  GET_PAYMENTS_ERROR: 'GET_PAYMENTS_ERROR',
};

export default paymentActionConstants;
